import{__require as s}from"../classes/range.js";const a=s();var e=(s,e)=>new a(s,e).set.map((s=>s.map((s=>s.value)).join(" ").trim().split(" ")));export{e as t};
